import React from 'react';
import './AppPageWrapper.css';
import AppHeader from '../components/AppHeader';

interface IProps {
  showNavBar?: boolean;
}

const AppPageWrapper: React.FC<IProps> = ({ children, showNavBar }) => {
  return (
    <div className="AppPageWrapper" style={{ paddingTop: showNavBar ? '70px' : undefined, margin: '0 auto' }}>
      {showNavBar && <AppHeader />}
      {children}
    </div>
  );
};

export { AppPageWrapper };
